import { requester } from '@space-shell/config/request'

import { ViewAsEndpoints } from './constants'
import type { FilterResponse } from './types'

class ViewAsService {
  static getClasses = async (membershipSlug: string, productId: string) => {
    const { data } = await requester.get<FilterResponse>(
      ViewAsEndpoints.get(membershipSlug, productId)
    )

    return data?.classes
  }
}

export default ViewAsService
